import React from 'react'
import HeartImg from 'src/assets/img/house/like.png'
import PropTypes from 'prop-types'

const LikeProfileCard = ({ like }) => {
  const formatLike = (value) => {
    const numValue = Number(value)
    if (numValue > 99999) {
      return '+99999'
    }
    return value
  }

  return (
    <div className="flex items-center gap-[2px] rounded-full bg-[#124957] px-1.5 py-0.5 xs:gap-1 xs:px-2 xs:py-1">
      <span className="w-4 h-4 xs:w-5 xs:h-5">
        <img className="w-full h-full" src={HeartImg} alt="rank" />
      </span>
      <span className="text-[10px] xs:text-xs font-medium text-white">{formatLike(like)}</span>
    </div>
  )
}

LikeProfileCard.propTypes = {
  like: PropTypes.string
}

export default LikeProfileCard
